import { Component, app, ojs } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import { eParse } from "../../helpers";
import { dc } from "../../declarations";
import { $e } from "../../ojs.events";
import FormField from "../Blocks/FormField";

const h = app("h");
const broker = app("broker");

ojs(FormField);

export default class DepositCapaForm extends Component {
    renderForm(...args) {
        return h.div(
            h.FormField({
                type: "number",
                id: "capa-deposit-price",
                oninput: this.method("toCapa", "${this}"),
                label: { value: `Price (${dc.userCurrency})` },
                helpText: { value: `Amount you want to pay` },

                // The elements whose `ff_dep_hook` attribute values are
                // listed depend on this input element's input event
                dependencies: ["dcf-capa-deposit-amount"],

                // This is the reference attribute that
                // other inputs this one depends on
                // can use to fire custom events
                // on it if something on them
                // changes, e.g., an input change.
                ff_dep_hook: "dcf-capa-deposit-price",
            }),
            h.FormField({
                type: "number",
                id: "capa-deposit-amount",
                oninput: this.method("toCost", "${this}"),
                label: { value: `Amount (${dc.capaSymbol})` },
                helpText: { value: `Amount of capa to deposit` },
                dependencies: ["dcf-capa-deposit-price"],
                ff_dep_hook: "dcf-capa-deposit-amount",
            }),
            ...args,
        );
    }

    toCapa(elem) {
        let input = dom.id("capa-deposit-amount");
        if (!input) return;
        input.value =
            elem.value == ""
                ? ""
                : Math.floor(
                      elem.value /
                          (window?.systemConfigs?.capaExchangeRate ?? 0.01),
                  );
        input.dispatchEvent(new CustomEvent("dependencyInput"));
    }

    toCost(elem) {
        let input = dom.id("capa-deposit-price");
        if (!input) return;
        input.value =
            elem.value == ""
                ? ""
                : Math.ceil(
                      elem.value *
                          (window?.systemConfigs?.capaExchangeRate ?? 0.01),
                  );
        input.dispatchEvent(new CustomEvent("dependencyInput"));
    }

    $$capa = {
        deposited: (ed, event) => {
            let data = eParse(ed);
            dom.id(data.meta.buttons.left)?.click();
        },

        is: {
            depositing: (ed, event) => {
                let data = eParse(ed);
                dom.id(data.meta.buttons.left)?.click();
            },
        },

        needs: {
            depositForm: (ed, event) => this.showForm(ed, event),
        },

        has: {
            depositError: (ed, event) => {
                let data = eParse(ed);
                const btn = dom.id(data.meta.buttons.right);

                dom.enable(btn);
                dom.put("Deposit", btn);
            },
        },
    };

    async showForm(ed, event) {
        // let data = eParse(ed);

        let options = new tool.ModalOptions();
        options.buttons.right.text = "Deposit";
        options.classes.buttons.right = "btn btn-success";

        options.staticBackdrop();

        const { buttons } = tool.modal(
            "Wallet Deposit",
            this.renderForm(),
            options,
        );

        buttons.right.button.addEventListener("click", function () {
            dom.disable(this);
            dom.put("...", this);

            broker.send(
                $e.capa.needs.purchase,
                payload(
                    {
                        amount: dom.id("capa-deposit-price")?.value ?? 0,
                    },
                    {
                        buttons: {
                            left: buttons.left.button.id,
                            right: buttons.right.button.id,
                        },
                    },
                ),
            );
        });
    }
}
